module.exports = __webpack_public_path__ + "videos/home_jp.9670652.mp4";